import type {Icon} from '@primer/octicons-react'

import type {CustomTemplate} from '../../../client/api/common-contracts'

export const SelectionOptionEnum = {
  table: 'table',
  board: 'board',
  roadmap: 'roadmap',
  feature: 'feature',
  backlog: 'backlog',
  template: 'template',
} as const

export type SelectionOptionEnum = ObjectValues<typeof SelectionOptionEnum>

export const GroupEnum = {
  layout: 'layout',
  functionality: 'functionality',
  org_templates: 'org_templates',
} as const

export type GroupEnum = ObjectValues<typeof GroupEnum>

export type SidePanelGroup = {
  key: GroupEnum
  groupTitle: string
  items: Array<SelectionOption> | [SelectionOption, SelectionOption]
}

export type SelectionOption = {
  key: string
  groupKey: GroupEnum
  title: string
  disabled?: boolean
  icon: Icon
  template: CustomTemplate | undefined
  action: (payload: {selectedTemplate: string; title: string; rollback?: () => void}) => void | Promise<void>
}
